module.exports = __webpack_public_path__ + "img/briefcase.119419c3.svg";